export default __webpack_public_path__ + "static/media/empty.744d762e.svg";